module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    class: ("c-image c-image--" + _vm.alignClass)
  }, [(_vm.title) ? _c('header', {
    staticClass: "c-image__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.image.url) ? _c('img', {
    staticClass: "c-image__media",
    attrs: {
      "src": _vm.image.url,
      "alt": _vm.image.alt,
      "width": _vm.image.width,
      "height": _vm.image.height
    }
  }) : _vm._e(), _vm._v(" "), (_vm.caption) ? _c('figcaption', {
    staticClass: "c-image__caption",
    domProps: {
      "innerHTML": _vm._s(_vm.caption)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3edb5e96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Image.vue
// module id = 79
// module chunks = 0